import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M12 19l.1162.0068c.4958.058.8838.4825.8838.9932v1c0 .55-.44 1-1 1l-.1162-.0068C11.388 21.9352 11 21.5107 11 21v-1c0-.55.45-1 1-1zm6.084-2.083A.9959.9959 0 0119.4 17l.39.38c.39.39.39 1.02 0 1.41l-.01.01c-.39.39-1.02.39-1.41 0l-.38-.39c-.39-.38-.39-1.01 0-1.41zM4.59 16.99c.39-.39 1.02-.39 1.41 0l.083.094A.9959.9959 0 016 18.4l-.38.39c-.39.4-1.03.4-1.42 0l-.083-.094A.9959.9959 0 014.2 17.38zM17 9c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2v-2c0-1.1.9-2 2-2zM4.294 5.227a.9959.9959 0 011.316.083l.39.38c.38.38.38 1.02 0 1.41l-.094.083A.9959.9959 0 014.59 7.1l-.39-.38a.9959.9959 0 010-1.41zM18.38 5.3c.39-.39 1.02-.39 1.41 0l.083.0942c.3047.3927.277.965-.083 1.3158l-.38.38c-.39.39-1.02.39-1.41 0l-.083-.094A.9959.9959 0 0118 5.68zM12 2l.1162.0068C12.612 2.0648 13 2.4893 13 3v1c0 .55-.45 1-1 1l-.1162-.0068C11.388 4.9352 11 4.5107 11 4V3c0-.55.44-1 1-1z"
  }],
  circles: []
};
var FlourescentIcon = function FlourescentIcon(props) {
  return renderIcon(props, iconType);
};
export { FlourescentIcon };